import { useState } from 'react';
import { API } from '@/lib/apiConfig';
import LoadingSpinner from '../components/common/LoadingSpinner';
import ErrorBanner from '../components/common/ErrorBanner';

export function RegulatorExport() {
  const [json, setJson] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const headers = { Authorization: 'Bearer devtoken' };

  const fetcher = async (path: string) => {
    setLoading(true);
    setError(null);
    setJson(null);
    try {
      const res = await fetch(`${API.regulator}${path}`, { headers });
      if (!res.ok) {
        throw new Error(`HTTP ${res.status}: ${res.statusText}`);
      }
      const data = await res.json();
      setJson(data);
    } catch (e) {
      const error = e instanceof Error ? e : new Error('Failed to fetch regulator data');
      setError(error);
      console.error('Regulator export failed:', e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-3">
      <div className="font-orbitron text-evat-gold">Regulator Export</div>
      
      <ErrorBanner error={error} onRetry={() => fetcher('/company/demo/emissions')} showRetry={!!error} />
      
      <div className="flex gap-2 flex-wrap">
        <button
          onClick={() => fetcher('/company/demo/emissions')}
          disabled={loading}
          className="px-3 py-1 rounded border border-evat-neon text-evat-neon hover:shadow-neon disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Emissions
        </button>
        <button
          onClick={() => fetcher('/company/demo/reduction')}
          disabled={loading}
          className="px-3 py-1 rounded border border-evat-gold text-evat-gold hover:shadow-neon disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Reduction
        </button>
        <button
          onClick={() => fetcher('/company/demo/certificates')}
          disabled={loading}
          className="px-3 py-1 rounded border border-evat-neon text-evat-neon hover:shadow-neon disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Certificates
        </button>
        <button
          onClick={() => fetcher('/company/demo/risk')}
          disabled={loading}
          className="px-3 py-1 rounded border border-evat-gold text-evat-gold hover:shadow-neon disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Risk
        </button>
      </div>
      
      {loading && <LoadingSpinner size="sm" text="Loading data..." />}
      
      {json && !loading && (
        <pre className="text-xs bg-black border border-neutral-700 rounded p-3 overflow-auto max-h-80">{JSON.stringify(json, null, 2)}</pre>
      )}
    </div>
  );
}

export default RegulatorExport;














